import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BdoDashboardComponent } from './components/bdo-dashboard/bdo-dashboard.component';



@NgModule({
  declarations: [BdoDashboardComponent],
  imports: [
    CommonModule
  ]
})
export class BdoDashboardModule { }
